module.exports = __webpack_public_path__ + "friday.ee4786b431e7f6ad0694.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/friday.woff?o83v8v
// module id = 1482
// module chunks = 0